module.exports = __webpack_public_path__ + "media/src/images/abouts/bg_image/app_image-f6fc10c66472a2c5504f69ca3a3afa6a.png";